export const RESET_STATE = {
  type: 'RESET',
};
